import { getExtensions } from '@/components/tiptap-editor/tiptap-editor';
import { browserServers } from '@/lib/servers';
import type { JSONContent } from '@tiptap/core';
import { stripCommentAnnotationsFromDoc } from '../comment-utils';
import { type SelectedZyVersionFilter } from '../zy-tiptap-utils';
import { colorizeCode, type ReferenceToContentResources } from '../zybooks-api';
import {
    buildColorizedZyCodeHtml as buildColorizedZyCodeHtmlCore,
    convertProseMirrorToZybooksJSONCore,
    transformDoc as transformDocCore,
    type ConvertProseMirrorToZybooksJSONDeps,
    type ConvertProseMirrorToZybooksJSONOptions,
} from './to-zybooks-json-core';

export { convertProseMirrorToZybooksJSONCore } from './to-zybooks-json-core';
export type { ConvertProseMirrorToZybooksJSONDeps, ConvertProseMirrorToZybooksJSONOptions } from './to-zybooks-json-core';

const browserConvertDeps: ConvertProseMirrorToZybooksJSONDeps = {
    getExtensions,
    servers: browserServers,
};

export const convertProseMirrorToZybooksJSON = async (
    prosemirrorDoc: JSONContent | string,
    options?: ConvertProseMirrorToZybooksJSONOptions,
): Promise<{ contentResources: any[]; enumMaps: Partial<ReferenceToContentResources> }> => {
    const rawDoc = typeof prosemirrorDoc === 'string' ? (JSON.parse(prosemirrorDoc) as JSONContent) : prosemirrorDoc;
    const doc = options?.preserveCommentAnnotations ? rawDoc : stripCommentAnnotationsFromDoc(rawDoc);
    return convertProseMirrorToZybooksJSONCore(doc, options, browserConvertDeps);
};

export function transformDoc(doc: JSONContent, selectedZyVersion: SelectedZyVersionFilter = null): JSONContent {
    return transformDocCore(doc, selectedZyVersion, browserConvertDeps);
}

export async function buildColorizedZyCodeHtml(codeText: string, attrs: Record<string, unknown> = {}): Promise<string> {
    return buildColorizedZyCodeHtmlCore(codeText, attrs, colorizeCode);
}

export default convertProseMirrorToZybooksJSON;
